module.exports = __webpack_public_path__ + "resources/img/img_rancher5.ab80eb33dee46d1b09ad43ba77938452.png";